import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro" style={{ textAlign: 'center' }}>
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Leo Dong</h2>
        <p><a href="mailto:hello@leodong.me">hello@leodong.me</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hey, I&apos;m Leo.
      </p>
      <p>
        Professionally, I lead data science at <a href="https://www.eucalyptus.health">Eucalyptus</a> / Hims &amp; Hers, building out an applied ML function in London focused on monetisation, churn and retention.
      </p>
      <p>
        Before that, I was at <a href="https://www.checkout.com">Checkout.com</a> running data science for their internal money flows
        and at <a href="https://www.sainsburys.co.uk">Sainsbury&apos;s</a> doing modelling with a customer marketing flavour.
        Even earlier, I was working in data science at <a href="https://www.commbank.com.au">the Commonwealth Bank of Australia</a> in
        the financial wellbeing space, building things like <a href="https://www.commbank.com.au/digital-banking/bill-sense.html">Bill Sense</a>.
      </p>
      <p>
        At home, I spend my free time <a href="https://blog.leodong.me">writing</a>, <a href="https://blog.leodong.me/tag/reviews/">reading</a> and <a href="/art">painting</a>.
        When I&apos;m out and about I am most likely travelling, playing
        football/futsal or doing some <a href="https://photo.leodong.me">photography</a>.
        Other things I have dabbled in include
        scuba diving, volleyball, netball and skiing.
      </p>
      <ul className="actions" style={{ textAlign: 'center' }}>
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Read More</Link> : <Link to="/blog" className="button">My Blog</Link>}
        </li>
      </ul>
    </section>

    <section id="footer" style={{ textAlign: 'center' }}>
      <ContactIcons />
    </section>
  </section>
);

export default SideBar;
